export const IPP_NA_LOCALES = ['en-US'] as const
export const IPP_EU_LOCALES = ['es-ES', 'fr-FR'] as const

/**
 * All supported IPP locales, composed of NA and EU locales.
 */
export const IPP_SUPPORTED_LOCALES = [...IPP_NA_LOCALES, ...IPP_EU_LOCALES] as const
export type IPP_SUPPORTED_LOCALE = 'en-US' | 'es-ES' | 'es-US' | 'fr-FR' | 'fr-CA'

export const IPP_DEFAULT_LOCALE: IPP_SUPPORTED_LOCALE = 'en-US'
